import { ReflectUtils } from "@dooboostore/core";
const SUBSCRIBE_SWC_APP_MESSAGE_METADATA_KEY = Symbol.for("simple-web-component:subscribe-swc-app-message");
function createSubscribeSwcAppMessage(options, messageType) {
  return (target, propertyKey, descriptor) => {
    const constructor = target.constructor;
    let list = ReflectUtils.getOwnMetadata(SUBSCRIBE_SWC_APP_MESSAGE_METADATA_KEY, constructor);
    if (!list) {
      list = [];
      ReflectUtils.defineMetadata(SUBSCRIBE_SWC_APP_MESSAGE_METADATA_KEY, list, constructor);
    }
    list.push({ propertyKey, messageType, filter: options?.filter, before: options?.before, finally: options?.finally, subject: options?.subject, trigger: options?.trigger });
    return descriptor;
  };
}
function subscribeSwcAppMessage(targetOrMessageTypeOrOptions, optionsOrPropertyKey, descriptor) {
  if (targetOrMessageTypeOrOptions && typeof targetOrMessageTypeOrOptions === "object" && optionsOrPropertyKey && (typeof optionsOrPropertyKey === "string" || typeof optionsOrPropertyKey === "symbol") && descriptor) {
    const target = targetOrMessageTypeOrOptions;
    const propertyKey = optionsOrPropertyKey;
    return createSubscribeSwcAppMessage({})(target, propertyKey, descriptor);
  }
  let messageType;
  let options = {};
  if (typeof targetOrMessageTypeOrOptions === "string") {
    messageType = targetOrMessageTypeOrOptions;
    if (optionsOrPropertyKey && typeof optionsOrPropertyKey === "object") {
      options = optionsOrPropertyKey;
    }
  } else if (targetOrMessageTypeOrOptions && typeof targetOrMessageTypeOrOptions === "object") {
    options = targetOrMessageTypeOrOptions;
  }
  return createSubscribeSwcAppMessage(options, messageType);
}
const receiveMessage = subscribeSwcAppMessage;
const withSubject = (subject, a, b, descriptor) => {
  if (descriptor) return createSubscribeSwcAppMessage({ subject })(a, b, descriptor);
  if (typeof a === "string") return createSubscribeSwcAppMessage({ ...b ?? {}, subject }, a);
  return createSubscribeSwcAppMessage({ ...a ?? {}, subject });
};
function subscribeSwcAppMessageBehavior(a, b, descriptor) {
  return withSubject("behavior", a, b, descriptor);
}
function subscribeSwcAppMessageReplay(a, b, descriptor) {
  return withSubject("replay", a, b, descriptor);
}
const getSubscribeSwcAppMessageMetadata = (target) => {
  const constructor = typeof target === "function" ? target : target.constructor;
  return ReflectUtils.findAllMetadata(SUBSCRIBE_SWC_APP_MESSAGE_METADATA_KEY, constructor).flat();
};
class MessageSubscribeLifeCycler {
  onConnected(_helperHostSet) {
  }
  /** SwcAppMixin 이 구독 대상 메타를 꺼낼 때 사용 */
  getMetadata(helperHostSet) {
    return getSubscribeSwcAppMessageMetadata(helperHostSet.$this);
  }
}
export {
  MessageSubscribeLifeCycler,
  SUBSCRIBE_SWC_APP_MESSAGE_METADATA_KEY,
  getSubscribeSwcAppMessageMetadata,
  receiveMessage,
  subscribeSwcAppMessage,
  subscribeSwcAppMessageBehavior,
  subscribeSwcAppMessageReplay
};
//# sourceMappingURL=subscribeSwcAppMessage.js.map
